// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/5e31e483/" + chunkId + "." + __webpack_require__.h() + ".v5e31e483.js";
};